import './styles.css';
import React, { useState, useEffect} from "react";
import { useDispatch } from "react-redux";
import { useQueries } from "@tanstack/react-query";
import { Card, Row, Col } from 'antd';
import { getLiveData } from 'apis/dataApis';
import { setPageLastUpdatedTime } from "reducers/loaderSlice";
import ToolBar from "./ToolBar";
import SynchronizedCharts from './SynchronizedCharts';
import VehicleCurrentStatus from '../VehicleCurrentStatus';


const RealTimeLayout = ({vehicle}) => {
  const dispatch = useDispatch();
  const [queryFields, setQueryFields] = useState({});
  const [queryList, setQueryList] = useState([]);  
  const [timeInterval, setTimeInterval] = useState(5);
  const [sampling, setSampling] = useState(null);
  const hexColors = ['#1f77b4', '#20de23', '#ea1809']

  const queriesResults = useQueries({
    queries: queryList.map(({table, fields}) => ({
      queryKey: ['realTimeData', vehicle.vehImei, fields, table, timeInterval, sampling],
      queryFn: async () => {
        const data = await getLiveData(vehicle.vehImei, 
        fields.map((f) => f.value), 
        table, 
        timeInterval, sampling);
        dispatch(setPageLastUpdatedTime(Date.now()));
        return data;
      },
      enabled: !!(vehicle.vehImei && fields && table, timeInterval),
      // onSuccess: dispatch(setPageLastUpdatedTime(Date.now())),
      keepPreviousData: true,
      refetchInterval: sampling ? 1 * 60 * 1000 : 10 * 1 * 1000,
    })),
  });

  const onChangeTime = (value) => {
    setTimeInterval(value);
    if (value > 5){
      setSampling('1m')
    }else{
      setSampling(null)
    }
  }

  const queryFieldsChange = (variables) => {
    setQueryFields(variables);
  }

  let datasets = []; let count = 0;
  queryList.forEach((table, index) => {
    if (table?.fields.length > 0){
      table.fields.forEach((field, i) => {
        const datasetItem = {
          title: field.title, 
          data: queriesResults?.[index]?.data?.data?.map((entry) => [entry?.timestamp, entry?.[field.value]]), 
          name: field, 
          type: 'spline', 
          color: hexColors[count], 
          unit: field.unit,
        }
        datasets.push(datasetItem);
        count++;
      })
    }
  })

  useEffect(() => {
    const dataKeys = Object.keys(queryFields);
    let selectedFields=[];
    dataKeys.forEach((dataKey) => {
      if (queryFields[dataKey].length){
        selectedFields.push({
          table: dataKey,
          fields: queryFields[dataKey]
        })
      }
    });
    setQueryList(selectedFields); 
  }, [queryFields])

  return (
    <>
      <div className="dbcontainer">
        <div className="toolbar">
          <ToolBar 
            queryFieldsChange={queryFieldsChange} 
            changeDateRange={onChangeTime}
          />
        </div>
      <div className="dashboard-layout">

      </div>
        <Row gutter={[10, 10]} className='mt1 h100'>
          <Col span={24}>
            <Row gutter={[10, 10]} className='h100'>
              <Col xs={24} md={9} lg={8} xl={6}>
                  <div className="panelStyle h100">
                    <Card title={'Current Status'} className='h100'>
                      <VehicleCurrentStatus vehicle={vehicle}/>
                    </Card>
                  </div>
              </Col>
              <Col xs={24} md={15} lg={16} xl={18}>
                  <div className="panelStyle">
                    <Card title={'Live Data'}>
                      <SynchronizedCharts 
                        dataset={datasets}
                        showMarker={sampling ? true : false} 
                      />
                    </Card>
                  </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>

    </>
  );
};

export default RealTimeLayout;
